import {
  EyeIcon,
  HandWithdrawIcon,
  PencilSimpleIcon,
  PlusCircleIcon,
  ShieldCheckIcon,
  TrashSimpleIcon
} from '@phosphor-icons/react'

export const permissionActionsLIst = [
  {
    id: 'totalPermission',
    label: 'Permissão Total',
    icon: <HandWithdrawIcon />
  },
  {
    id: 'approve',
    label: 'Aprovar',
    icon: <ShieldCheckIcon />
  },
  {
    id: 'edit',
    label: 'Editar',
    icon: <PencilSimpleIcon />
  },
  {
    id: 'include',
    label: 'Incluir',
    icon: <PlusCircleIcon />
  },
  {
    id: 'view',
    label: 'Visualizar',
    icon: <EyeIcon />
  },
  {
    id: 'delete',
    label: 'Excluir',
    icon: <TrashSimpleIcon />
  }
]
